module.exports = __webpack_public_path__ + "static/media/blockly-2.47ef434e.png";